import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { useUserProfile } from 'APP/main/hooks/userProfile/useUserProfile';

import { useUserPresenter } from './NewUsersPopupUserItem.presenter';

export const NewUsersPopupUserItem = observer(({ userId, closePopup, groupId, messageId }) => {
  const userProfile = useUserProfile(userId, { groupId, messageId });
  const presenter = useUserPresenter({ userId, closePopup });
  const containerProps = classNames(popupItemStyles.container, popupItemStyles.interactive);

  return (
    <button
      className={containerProps}
      onClick={userProfile.show}
    >
      <PopupInfoCard
        type={AvatarTypes.Round_10}
        className={popupItemStyles.card}
        avatarTitle={presenter.avatarTitle}
        avatarUrl={presenter.avatarUrl}
        avatarBackgroundColorIndex={presenter.avatarBackgroundColorIndex}
        title={presenter.title}
        subtitle={presenter.subtitle}
      />
    </button>
  );
});
